<template>
  <b-row>
    <b-col cols="12">
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="text-body font-weight-bold">
          Business Development Manager Dashboard
        </h3>
        <b-link to="/bdm-profile">
          <b-button variant="primary">
            <feather-icon icon="UserIcon" />
            Manage BDMs Profiles
          </b-button>
        </b-link>
      </div>
    </b-col>
    <b-col cols="12" class="mt-1">
      <b-row>
        <b-col cols="12" md="3">
          <b-card>
            <h6>Total BDMs</h6>
            <b-skeleton v-if="loadingStats" width="80px" height="25px" />

            <h3 v-else>{{ stats.totalBdmUser }}</h3>
            <small class="text-success">+2 this month</small>
          </b-card>
        </b-col>

        <b-col cols="12" md="3">
          <b-card>
            <h6>Avg. Customers per BDM</h6>
            <b-skeleton v-if="loadingStats" width="80px" height="25px" />
            <h3 v-else>{{ stats.avgCustomerPerBdm.toFixed(2) }}</h3>
            <small class="text-success">+5% vs last month</small>
          </b-card>
        </b-col>

        <b-col cols="12" md="3">
          <b-card>
            <h6>Top BDM Revenue</h6>
            <b-skeleton v-if="loadingStats" width="80px" height="25px" />
            <h3 v-else>${{ formatBDMRevenue(stats.totalRevenue) }}</h3>
            <small class="text-muted">Michael Hughes</small>
          </b-card>
        </b-col>

        <b-col cols="12" md="3">
          <b-card>
            <h6>Unassigned Customers</h6>
            <b-skeleton v-if="loadingStats" width="80px" height="25px" />
            <h3>{{ stats.totalUnAssignBdm }}</h3>
            <small class="text-danger">Needs assignment</small>
          </b-card>
        </b-col>
      </b-row>
    </b-col>

    <b-col cols="12">
      <b-card>
        <PerformanceMonthly />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card>
        <PerformanceLifeTime />
      </b-card>
    </b-col>

    <b-col cols="12">
      <b-card>
        <CustomerAssignment />
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BFormSelect,
  BFormInput,
  BButton,
  BTable,
  BAvatar,
  BFormCheckbox,
  BModal,
  BBadge,
  BLink,
  BSkeleton,
} from "bootstrap-vue";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";
import { mapState, mapActions } from "vuex";
import CustomerAssignment from "./CustomerAssignment.vue";
import PerformanceMonthly from "./PerformanceMonthly.vue";
import PerformanceLifeTime from "./PerformanceLifeTime.vue";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BFormSelect,
    BFormInput,
    BButton,
    BTable,
    BAvatar,
    BFormCheckbox,
    BBadge,
    BModal,
    BLink,
    CustomerAssignment,
    BSkeleton,
    PerformanceMonthly,
    PerformanceLifeTime,
  },
  data() {
    return {
    };
  },
  created() {
    this.getAffiliateStatistics();
  },
  computed: {
    ...mapState("bdm/affiliates/list", {
      stats: (state) => state.stats,
      loadingStats: (state) => state.loadingStats,
    }),
  },
  methods: {
    formatCurrencyBuiltInFunc,
    ...mapActions("bdm/affiliates/list", ["getAffiliateStatistics"]),
    formatBDMRevenue(value) {
      if (value === null || value === undefined) return "-";
      const absValue = Math.abs(value);
      const sign = value < 0 ? "-" : "";
      if (absValue >= 1000000) {
        return (
          sign + (absValue / 1000000).toFixed(2).replace(/\.00$/, "") + "M"
        );
      }
      if (absValue >= 1000) {
        return sign + (absValue / 1000).toFixed(2).replace(/\.00$/, "") + "K";
      }
      return sign + absValue.toString();
    },
  },
};
</script>
